import { Ulid } from "@kase/my-marathon-communication";
import { TimeContract } from "./interfaces";

const findContract = (contracts: TimeContract[], date: Date) => {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    for (let i = contracts.length - 1; i >= 0; --i) {
        const contract = contracts[i];

        if (contract.year !== year || contract.month !== month) {
            continue;
        }

        let isInRange = true;

        if (contract.from && contract.from > date) {
            isInRange = false;
        }

        if (contract.to && contract.to < date) {
            isInRange = false;
        }

        if (isInRange) {
            return contract;
        }
    }

    return null;
};

export const getDayContract = (contracts: TimeContract[], date: Date) => {
    const day = date.getDate();
    const contract = findContract(contracts, date);

    return contract?.days.find((item) => item.day === day) ?? null;
};

export const getContractKey = (id: string | Readonly<Ulid>, year: number) =>
    `${id.toString()}-${year}`;

export const isContractKey = (id: string | Readonly<Ulid>, key: string) =>
    key.startsWith(`${id.toString()}-`);
